/**
 * Relative-time formatter for notifications. Finer-grained than the shared
 * `formatDate` (which collapses everything < 1 day to "Today") because
 * notifications often arrive minutes apart and the bell needs to communicate
 * recency at a glance.
 *
 * Output examples: "just now", "12m", "3h", "Yesterday", "Apr 21".
 */
export function formatNotificationTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return '';
  const diffSec = Math.floor((Date.now() - then.getTime()) / 1000);

  if (diffSec < 30) return 'just now';
  if (diffSec < 60) return `${diffSec}s`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h`;
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay === 1) return 'Yesterday';
  if (diffDay < 7) return `${diffDay}d`;

  return then.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
